import { SentryContainer } from ".";

export interface Identify {
  Email: string;
  Customer: string;
  "CUSTOM DOMAIN"?: string;
  "Portal Name": string;
  "Portal Display Name": string;
}
interface errorMonitorProps {
  init(): void;
  identify(value: Identify): void;
  logError(error: Error, errorInfo?: any): void;

}

export const errorMonitor: errorMonitorProps = {
  init() {
    SentryContainer.init();
  },
  identify(value: Identify): void {
    SentryContainer.identify(value);
  },
  logError(error: Error, errorInfo?: any): void {
    SentryContainer.logError(error, errorInfo);
  },

};
